import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        provinces: false
      },
      options: {
        provinces: []
      },
      selected: {
        province: '',
        tagging: 0
      },
      editable: {
        province: ''
      }
    }
  },

  watch: {
    'selected.region' (region) {
      if (region?.id) {
        this.getProvinces(this, '', region.id).finally(() => {
          if (this.editable.province) {
            this.selected.province = QUERY.find(this.options.provinces, {
              id: this.editable.province
            }) || ''
            this.editable.province = ''
          }
        })
      } else {
        this.selected.province = ''
        this.options.provinces = []
      }
    }
  },

  methods: {

    async getProvinces (context, search = '', region = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.province
      const fetching = context.fetching?.provinces
      const options = context.options?.provinces

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.provinces = true
      context.selected.province = ''

      const filters = {
        filter_text: search,
        tagging: context.selected.tagging,
        region_id: region
      }

      return await SSharedList.getProvinces(filters).then(
        ({ data }) => {
          context.options.provinces = data
        }
      ).catch(() => {
        context.options.provinces = []
      }).finally(() => {
        context.fetching.provinces = false
      })
    },

    async searchProvinces (search, loading) {
      this.searchProvincesProvider(this, search, loading)
    },

    searchProvincesProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.provinces, {
          keys: ['province_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            tagging: selected.tagging,
            region_id: selected.region?.id || ''
          }

          SSharedList.getProvinces(filters).then(
            ({ data }) => {
              options.provinces = data
            }
          ).catch(() => {
            options.provinces = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
